<template>
    <div class="my-8 md:my-16 space-y-8">
        <div class="max-w-2xl mx-auto">
            <div class="text-center">
                <i class="icon-check-bold mx-auto size-16 rounded-full flex items-center justify-center bg-green-50 text-3xl text-green-700" />
            </div>
            <div class="space-y-3 my-6 text-center">
                <h1 class="text-center text-2xl font-semibold leading-tight text-gray-800">
                    {{ $t('Your inquiry has been sent.') }}
                </h1>
                <p class="text-sm text-gray-600">
                    {{ $t('We will send you a message with the details of your order to your email address.') }}
                    <br />
                    {{ $t('We need to check the availability of the appointment. You can expect an offer within 48 hours.') }}
                </p>
                <div class="text-center text-gray-600" v-html="$t('Yout inquiry number is :order_number', { number: order.orderNumber })" />
            </div>
        </div>
        <div class="max-w-xl mx-auto">
            <OrderSummary v-if="order" :order="order" />
        </div>
    </div>
</template>

<script setup>
import OrderSummary from './_partials/OrderSummary.vue'
import { useAsyncRequest } from '@/composables/useAsyncRequest'

const props = defineProps({
    orderId: {
        type: String,
        required: true
    }
})
const order = ref(null)
const { get } = useAsyncRequest()

const response = await get(`/api/orders/${props.orderId}`)

order.value = response.order
</script>
